import React, { useEffect, useState } from 'react';
import { getSellerFinanceLedger, getSellerFinanceSummary } from '../../api';

const rub = (minor) => `${((minor || 0) / 100).toLocaleString('ru-RU', { minimumFractionDigits: 2 })} ₽`;

export default function FinanceTab({ managedByMaxMarket = false }) {
  const [summary, setSummary] = useState(null);
  const [ledger, setLedger] = useState([]);
  useEffect(() => {
    Promise.all([getSellerFinanceSummary(), getSellerFinanceLedger({ page: 1, pageSize: 50 })])
      .then(([summaryResponse, ledgerResponse]) => { setSummary(summaryResponse.data); setLedger(ledgerResponse.data.items || []); })
      .catch(() => { setSummary(null); });
  }, []);
  if (!summary) return <p>Финансовая информация пока недоступна.</p>;
  return <section>
    <h2>Финансы</h2>
    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
      <div><small>Ожидается</small><h3>{rub(summary.pendingMinor)}</h3></div>
      <div><small>Доступно к выплате</small><h3>{rub(summary.availableMinor)}</h3></div>
      <div><small>Закрыто в расчёте</small><h3>{rub(summary.settledMinor)}</h3></div>
    </div>
    <p>{managedByMaxMarket
      ? 'Начисления рассчитаны по закупочным ценам. Администратор отмечает выполненный перевод после расчёта в банке.'
      : 'Здесь показаны внутренние начисления и статусы расчётов на площадке.'}</p>
    <h3>История операций</h3>
    <div style={{ overflowX: 'auto' }}><table><thead><tr><th>Дата</th><th>Заказ</th><th>Операция</th><th>Сумма</th><th>Статус</th></tr></thead><tbody>{ledger.map(item => <tr key={item.id}><td>{new Date(item.date).toLocaleDateString('ru-RU')}</td><td>{item.orderReference || '—'}</td><td>{item.description || item.type}</td><td>{rub(item.amountMinor)}</td><td>{item.status}</td></tr>)}</tbody></table></div>
  </section>;
}
